// src/context/prospect/ProspectState.js
import React, { useReducer } from "react";
import axios from "axios";
import prospectReducer from "./prospectReducer";
import ProspectContext from "./prospectContext"; // <-- import the context

const ProspectState = (props) => {
  const initialState = {
    creating: false,
    error: null,
    lastProspect: null,
    cronRunning: false,
    lastCronResult: null,
  };

  const [state, dispatch] = useReducer(prospectReducer, initialState);

  const createProspect = async (payload) => {
    dispatch({ type: "CREATING_PROSPECT" });
    try {
      console.log(payload);
      const response = await axios.post("/api/prospects", payload);
      dispatch({ type: "PROSPECT_CREATED", payload: response.data });
    } catch (error) {
      dispatch({
        type: "PROSPECT_ERROR",
        payload:
          error?.response?.data ||
          error.message ||
          "Failed to create prospect.",
      });
    }
  };

  const runDailyCron = async () => {
    dispatch({ type: "CRON_RUNNING" });
    try {
      const response = await axios.post("/prospects/cron/daily");
      dispatch({ type: "CRON_DONE", payload: response.data });
    } catch (error) {
      dispatch({
        type: "CRON_ERROR",
        payload:
          error?.response?.data || error.message || "Failed to run cron.",
      });
    }
  };

  // ✅ Use the context provider here, not <ProspectState>
  return (
    <ProspectContext.Provider
      value={{
        createProspect,
        runDailyCron,
        creating: state.creating,
        error: state.error,
        lastProspect: state.lastProspect,
        cronRunning: state.cronRunning,
        lastCronResult: state.lastCronResult,
      }}
    >
      {props.children}
    </ProspectContext.Provider>
  );
};

export default ProspectState;
